import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { install } from 'resize-observer';

// Polyfill for legacy browsers https://caniuse.com/resizeobserver
if (!window.ResizeObserver) install();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
